import {
  FloatingArrow,
  arrow,
  autoUpdate,
  offset,
  useFloating,
} from '@floating-ui/react';
import React, { useRef } from 'react';

import styles from './HelpBox.scss';

interface HelpBoxProps {
  parent: HTMLDivElement | HTMLButtonElement | null;
  children: React.ReactNode;
  dark?: boolean;
}

const HelpBox: React.FC<HelpBoxProps> = ({
  parent,
  children,
  dark = false,
}) => {
  const arrowRef = useRef(null);

  const { refs, floatingStyles, context } = useFloating({
    placement: 'top',
    middleware: [arrow({ element: arrowRef }), offset({ mainAxis: 25 })],
    elements: {
      reference: parent,
    },
    whileElementsMounted: autoUpdate,
  });

  return (
    <div
      ref={refs.setFloating}
      style={floatingStyles}
      className={`${styles.HelpBox} ${dark ? styles.HelpBox__Dark : ''}`}
    >
      {children}
      <FloatingArrow
        context={context}
        ref={arrowRef}
        className={`${styles.HelpBox__Arrow} ${
          dark ? styles.HelpBox__Arrow__Dark : ''
        }`}
      />
    </div>
  );
};

export default HelpBox;
